export default __webpack_public_path__ + "static/media/carousel5.9b34c5db.png";